/* eslint-disable no-unused-vars */
import Vue from 'vue';
import 'primevue/resources/themes/nova/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

//prime vue components
import Button from 'primevue/button';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import TabPanel from 'primevue/tabpanel';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import Textarea from 'primevue/textarea';
import AutoComplete from 'primevue/autocomplete';
import Paginator from 'primevue/paginator';
import Message from 'primevue/message';
import Checkbox from 'primevue/checkbox';
import ConfirmationService from 'primevue/confirmationservice';
import ConfirmPopup from 'primevue/confirmpopup';
import ConfirmDialog from 'primevue/confirmdialog';
import PrimeVue from 'primevue/config';
import DataView from 'primevue/dataview';
import ScrollTop from 'primevue/scrolltop';
import Breadcrumb from 'primevue/breadcrumb';
import Skeleton from 'primevue/skeleton';
import MultiSelect from 'primevue/multiselect';
import Chips from 'primevue/chips';
//import SimpleVueValidation from 'simple-vue-validator';
//const Validator = SimpleVueValidation.Validator;


Vue.component('Button', Button);
Vue.component('Toast', Toast);
Vue.component('DataTable', DataTable);
Vue.component('Column', Column);
Vue.component('ColumnGroup', ColumnGroup);
Vue.component('Dialog', Dialog);
Vue.component('InputText', InputText);
Vue.component('Dropdown', Dropdown);
Vue.component('Textarea', Textarea);
Vue.component('TabPanel', TabPanel);
Vue.component('AutoComplete', AutoComplete);
Vue.component('Paginator', Paginator)
Vue.component('Message', Message)
Vue.component('Checkbox', Checkbox)
Vue.component('DataView', DataView)
Vue.component('ConfirmPopup', ConfirmPopup)
Vue.component('ConfirmDialog', ConfirmDialog)
Vue.component('ScrollTop', ScrollTop)
Vue.component('Breadcrumb', Breadcrumb)
Vue.component('Skeleton', Skeleton)
Vue.component('MultiSelect', MultiSelect)
Vue.component('Chips', Chips)
    //Vue.use(SimpleVueValidation);



Vue.use(PrimeVue);

Vue.use(ToastService);
Vue.use(ConfirmationService);
//Vue.directive('ripple', Ripple);

export default {
    name: "primevue"
};